<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3>{{ 'PENDING_INVITATIONS.FILTER_CTA' | translate }}</h3>

    <form
      [formGroup]="pending_invitations_filter_form_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'PENDING_INVITATIONS.RECIPIENT_EMAIL_LABEL' | translate}} </mat-label>
        <input
          matInput
          type="text"
          formControlName="recipient_email"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'PENDING_INVITATIONS.COMPANY_BUSINESS_NAME_LABEL' | translate}} </mat-label>
        <input
          matInput
          type="text"
          formControlName="company_business_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'PENDING_INVITATIONS.SENDER_EMAIL_LABEL' | translate}} </mat-label>
        <input
          matInput
          type="text"
          formControlName="sender_email"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'PENDING_INVITATIONS.COMPANY_ID_LABEL' | translate}} </mat-label>
        <input
          matInput
          type="text"
          formControlName="company_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <div class="sp-row__end sp-width__full sp-margin__top">
        <p
          (click)="onClearFiltersClick()"
          class="p-color__accent sp-text__right sp-text__hover">
          {{ 'GENERAL.CLEAR_FILTERS_CTA' | translate }}
        </p>
      </div>

      <div class="sp-margin__top-x4 sp-width__full">
        <app-shared-button
          class="sp-width__full"
          [cta]="'GENERAL.APPLY_FILTERS_CTA'"
          [is_disabled]="!isFormValid()"
          (button_click)="onApplyFiltersClick()"></app-shared-button>
      </div>
    </form>
  </div>
</div>
